import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { PaginatedFreelancesDisplayer } from "./freelances";
import { RoundBluePlain, RoundGreyPlain, RoundWhitePlain } from "components/ui/Buttons/generic/GenericButton";
import WorldMapStats from "./parts/WolrdMapsStats";
import { ContactUs, PayementComponent } from "./commentCamarche";
import { CategSliderContainer } from "./accueil";

import { ReactElement, useEffect, useState } from "react";

import seotextsJSON from "../assets/seotexts.json";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import TwoByTwoSlider from "./parts/twoByTwoSlider";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import React from "react";
import { BigWhiteButton } from "./profile";
import { useRecoilState } from "recoil";
import { global_domain_id } from "./freelance/states";

gsap.registerPlugin(ScrollTrigger);

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
};

const SubCategory= () => {

    const {query}= useParams<{query: string}>();
    const seotexts: any= {...seotextsJSON};
    const [data, setData]= useState<any>({meta: "", data: [], cta: {h2: "", paragraph: ""}, titles: {h1: [], h2: []}});
    const [liveAveragePriceData, setLiveAveragePriceData]= useState([])

    const location= useLocation();//<-Without this the query is not excecuted if one navigates between the subcategories

    const AverageDisplay = React.memo(AverageDisplayer, (prevProps, nextProps) => {
        return (
          prevProps.data === nextProps.data &&
          prevProps.liveAveragePriceData === nextProps.liveAveragePriceData
        );
      });
      

    useEffect(()=> {
        if (query && seotexts[query]){
            document.title= seotexts[query].meta.title;
            setDescription(seotexts[query].meta.desc);
            setData(seotexts[query]);
        } else {
            document.title= "Plateforme freelance innovante - Wall of Share";
            const desc= "Rejoignez Wall of Share, la plateforme innovante qui connecte entreprises et freelances pour des collaborations efficaces et flexibles.";
            setDescription(desc);
        }
    }, [location]);//<-The data is forced to be updated everytime the route changes, even if we stay in the same component, there is a reason for that

    return<>
    <div className="w-full max-w-[100vw] relative">
        <Header type="default" />

        <Banner data={data}/>
        <SliderByTwo />
        <div className="w-full max-w-[100vw] pt-[150px]">
            <PaginatedFreelancesDisplayer onSetLiveAveragePriceData={setLiveAveragePriceData} />
        </div>

        <div className="w-full max-w-[100vw] mt-[120px]">
            <WeirdCallToAction />
        </div>

        <div className="w-full max-w-[100vw] bg-white lg:py-[140px] py-[100px]">
            <AverageDisplay data={data} liveAveragePriceData={liveAveragePriceData} />
        </div>

        <CommentCa />

        <div className="w-full w-[100vw] my-[130px]">
            {
                data.extras ?
                <Extras data={data} fat={true}/>
                :
                <BlueBanner />
            }
        </div>

        <div className="w-full max-w-[100vw] pb-[186px]">
            <SEOtext content={data}/>
        </div>

        <WorldMapStats />
        <PayementComponent isFreelance={false}/>


        <CategSliderContainer title="Trouvez le freelance qu'il vous faut !" bg="#fff" small={false}/>

        <ContactUs isFreelance={true}/>

        <FooterMaximized />
    </div>
    </>;
};

const SEOtext= ({content}: {content: any}) => {
    return<>
        <div className="xl:w-[80%] w-[80%] max-w-[1160px] mx-auto flex lg:flex-row flex-col lg:items-stretch justify-between gap-[78px]" >
            <div className="w-full lg:max-w-[640px] flex flex-col gap-[60px] grow"><SEOgenericContent content={content} /></div>
            <div className="relative grow-0 lg:max-w-[74%]">
                <div className="lg:sticky lg:top-[40px] bg-[#f4f4f5] rounded-[40px] px-[40px] lg:py-[40px] py-[50px] flex flex-col gap-[20px] lg:w-[400px] w-full">
                    <div className="lg:text-[22px] lg:leading-[26.4px] text-[16px] leading-[20.83px] font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">
                        Rejoignez Wall of Share
                    </div>
                    <h2 className="lg:text-[22px] lg:leading-[26.4px] text-[24px] leading-[28px] font-semibold text-primary-blue">{content.cta.h2}</h2>
                    <p className="font-dm-sans text-[#6f6f6f] lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] font-normal">{content.cta.paragraph}</p>
                    <RoundGreyPlain text="Contactez-nous" to="/contactez-nous" isButton={false} className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" />
                </div>
            </div>
        </div>
    </>;
};

export const SEOgenericContent= ({content, lessSpace= false, indent= false}: {content: any, lessSpace?: boolean, indent?: boolean})=> {
    return<>
        {
            content.data.map((section: any, index: number)=> (
                <SEOsection h2={section.h2} key={"item" + index} lessSpace={lessSpace}>
                    {
                        section.contents.map((element: any, id: number)=> (
                            element.type=== "paragraph" ?
                            <SEOparagraph key={"item-" + index + "-" + id} indent={indent} h3={element.h3}>{element.inner}</SEOparagraph>
                            :
                            element.type=== "list" ?
                            <SEOlist key={"item-" + index + "-" + id} lessSpace={lessSpace} indent={indent}>
                                {
                                    element.inner.map((el: any, num: number)=> (
                                        <SEOlistItem h3={el.h3} key={"item-" + index + "-" + id + "-" + num}>
                                            <>
                                            {el.paragraph!== undefined ? <SEOparagraph>{el.paragraph}</SEOparagraph> : <></>}
                                            {el.table!== undefined ? <SEOtable trs={el.table.tr} ths={el.table.th} /> : <></>}
                                            </>
                                        </SEOlistItem>
                                    ))
                                }
                            </SEOlist>
                            :
                            element.type=== "table" ?
                            <SEOtable trs={element.inner.tr} ths={element.inner.th} />
                            :
                            element.type==="title" ?
                            <SEOtitle indent={indent} h3={element.inner} />
                            :
                            <></>
                        ))
                    }
                </SEOsection>
            ))
        }
    </>;
};

const SEOtable= ({ths, trs}: {ths: string[], trs: string[][]}) => {
    return <div className="overflow-x-auto SEO-table-wrapper">
        <table className="table-auto border-collapse text-[#6f6f6f] lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] font-normal font-dm-sans">
            <thead>
                <tr>
                    {
                        ths.map((th: string) => (
                            <th className="font-semibold text-primary-blue p-2 border-[1px] border-[#6f6f6f]">{th}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    trs.map((tr: string[]) => (
                        <tr>
                            {
                                tr.map((td: string) => (

                                    <td className="p-2 border-[1px] border-[#6f6f6f] whitespace-pre-line">{td}</td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    </div>;
};

const SEOlist= ({children, lessSpace= false, indent= false}: {children: JSX.Element, lessSpace?: boolean, indent?: boolean}) => {
    let cName= "list-disc ml-[2rem] flex flex-col";
    cName+= lessSpace ? " gap-[5px]" : " gap-[20px]";
    cName+= indent ? " md:ml-[70px] ml-[40px]" : "";
    return <ul className={cName}>{children}</ul>;
};

const SEOlistItem= ({h3= undefined, indent= false, children}: {h3: string|undefined, children: ReactElement, indent?: boolean}) => {
    return<li>
        {
            h3!== undefined
            &&
            <h3 className="text-primary-blue text-[20px] leading-[26.04px] font-semibold">{h3}</h3>
        }
        <>{children}</>
    </li>
};

const SEOsection= ({h2, children, lessSpace= false}: {h2: string, children: JSX.Element, lessSpace?: boolean}) => {
    let cName= "flex flex-col";
    cName+= lessSpace ? " gap-[7px]" : " gap-[20px]";
    return<>
        <div className={cName}>
            <h2 className="text-primary-blue lg:text-[30px] lg:leading-[36px] text-[22px] leading-[26.4px] font-semibold">{h2}</h2>
            {children}
        </div>
    </>;
};

const SEOparagraph= ({children, indent= false, h3}: {children: string, indent?: boolean, h3?:string}) => {
    let cName= "text-[#6f6f6f] lg:text-[18px] lg:leading-[23.44px] text-[16px] leading-[20.83px] font-normal font-dm-sans whitespace-pre-line";
    cName+= indent ? " md:ml-[30px] ml-[15px]" : "";
    return<>
        <div className="flex flex-col gap-[.2rem]">
            {h3 && <h3 className="text-primary-blue text-[20px] leading-[26.04px] font-semibold">{h3}</h3>}
            <p className={cName}>{children}</p>
        </div>
    </>;
};

const SEOtitle= ({h3, indent= false}: {h3: string, indent?: boolean}) => {
    let cName= "text-primary-blue text-[20px] leading-[26.04px] font-semibold";
    cName+= indent ? " md:ml-[30px] ml-[15px]" : "";
    return <h3 className={cName}>{h3}</h3>;
};

const AverageDisplayer= ({data, liveAveragePriceData}: any) => {
    const mock_data= [
        {
            "job": {
            "jobTitle": "Software Engineer",
            "outSalary": 174,
            "inSalary": 150,
            "inMonthlySalary": 1809
            }
        }, {
            "job": {
            "jobTitle": "Web Developer",
            "outSalary": 332,
            "inSalary": 146,
            "inMonthlySalary": 1915
            }
        }, {
            "job": {
            "jobTitle": "Mobile App Developer",
            "outSalary": 173,
            "inSalary": 172,
            "inMonthlySalary": 1984
            }
        }, {
            "job": {
            "jobTitle": "Full Stack Developer",
            "outSalary": 248,
            "inSalary": 103,
            "inMonthlySalary": 1476
            }
        }, {
            "job": {
            "jobTitle": "Front End Developer",
            "outSalary": 455,
            "inSalary": 190,
            "inMonthlySalary": 514
            }
        }, {
            "job": {
            "jobTitle": "Back End Developer",
            "outSalary": 145,
            "inSalary": 13,
            "inMonthlySalary": 570
            }
        }, {
            "job": {
            "jobTitle": "DevOps Engineer",
            "outSalary": 343,
            "inSalary": 135,
            "inMonthlySalary": 346
            }
        }, {
            "job": {
            "jobTitle": "Data Scientist",
            "outSalary": 499,
            "inSalary": 14,
            "inMonthlySalary": 1612
            }
        }, {
            "job": {
            "jobTitle": "UI/UX Designer",
            "outSalary": 483,
            "inSalary": 128,
            "inMonthlySalary": 1492
            }
        }, {
            "job": {
            "jobTitle": "Quality Assurance Engineer",
            "outSalary": 369,
            "inSalary": 10,
            "inMonthlySalary": 1990
            }
        }, {
            "job": {
            "jobTitle": "Systems Analyst",
            "outSalary": 444,
            "inSalary": 51,
            "inMonthlySalary": 1600
            }
        }, {
            "job": {
            "jobTitle": "Database Administrator",
            "outSalary": 284,
            "inSalary": 42,
            "inMonthlySalary": 1817
            }
        }, {
            "job": {
            "jobTitle": "Network Engineer",
            "outSalary": 144,
            "inSalary": 96,
            "inMonthlySalary": 1063
            }
        }
    ]

    useEffect(()=>{
        console.log({liveAveragePriceData})
    }, [liveAveragePriceData])
    return <>
        <div className="w-[74%] max-w-[1048px] flex flex-col gap-[60px] items-center mx-auto">
            <div className="flex flex-col items-center max-w-[1012px] gap-[20px] mx-auto">
                <h2 className="lg:text-[40px] text-primary-blue lg:leading-[48px] text-[25px] leading-[30px] font-semibold text-center">
                    {
                        data.titles.h2.map((obj: {text: string, isgrad: boolean}, index: number)=> (
                            obj.isgrad ?
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500" key={"h2-" + index}>{obj.text}</span>
                                :
                                <span key={"h2-" + index}>{obj.text}</span>
                        ))
                    }
                </h2>
                <p className="text-[#6f6f6f] text-[16px] leading-[20.83px] lg:text-[22px] lg:leading-[28.64px] font-dm-sans text-center">Avec Wall of Share, accédez à des talents experts à des tarifs compétitifs avec des prestations mensuelles pour un suivi régulier et une meilleure maîtrise de votre budget.</p>
            </div>
            {/* <div className="w-full flex flex-row flex-wrap items-center justify-center gap-[20px]"> */}
            <div className="w-full grid xl:grid-cols-3 gap-[20px]">
                {
                    liveAveragePriceData?.map((data: any, index: number)=>(
                        <SalaryCompareCard jobTitle={data.job.jobTitle} inSalary={data.job.inSalary} outSalary={data.job.outSalary} inMonthly={data.job.inMonthlySalary}/>
                    ))
                }
            </div>
            <div className="max-w-[424px] flex flex-col gap-[10px] items-center justify-center">
                <p className="lg:text-[20px] lg:leading-[26.04px] text-[15px] leading-[19.53px] font-dm-sans text-center text-[#6f6f6f]">Rejoignez Wall of Share et profitez de freelances expérimentés à des prix attractifs.</p>
                <RoundWhitePlain text="Inscrivez vous" isButton={false} to="/inscription-entreprises" className="lg:px-[134px] px-[92px] py-[16px] lg:text-[23px] lg:leading-[29.5px] text-[20px] leading-[26.04px] w-max" />
            </div>
        </div>
    </>;
};

const SalaryCompareCard= ({jobTitle, outSalary, inSalary, inMonthly}:{jobTitle: string, outSalary: number, inSalary: number, inMonthly: number})=> {
    return<>
        <div className="max-w-[335px] w-full min-h-[165px] bg-[#f4f4f5] rounded-[20px] flex flex-col gap-[10px] items-start px-[30px] py-[20px]">
            <div className="text-[18px] leading-[23.44px] font-semibold text-primary-blue">{jobTitle}</div>
            <div className="flex flex-col gap-[10px]">
                <div className="flex flex-col">
                    <div className="text-[15px] leading-[19.53px] font-normal font-dm-sans text-[#706d6d]">Plateforme Freelance Europe</div>
                    <div className="text-[15px] leading-[19.53px] font-medium font-dm-sans text-[#000000]">{outSalary}</div>
                </div>
                <div className="flex flex-col">
                    <div className="text-[15px] leading-[19.53px] font-normal font-dm-sans text-[#706d6d]">Prix moyen Wall Of Share</div>
                    <div className="text-[15px] leading-[19.53px] font-medium font-dm-sans text-[#000000]">{inSalary} <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">{inMonthly}</span></div>
                </div>
            </div>
        </div>
    </>;
};

export const Banner= ({data, nobg= false, slim= false}: any) => {
    let wrapperCname= "w-full relative flex items-center justify-center";
    wrapperCname+= slim ? " lg:h-[350px] h-[200px]" :  data.extras ? " pt-[125px] pb-[81px]" : " lg:h-[495px] h-[292px]";
    wrapperCname+= nobg ? " bg-primary-blue" : " bg-cover bg-center bg-norepeat";
    let titleCname= "text-white lg:text-[70px] lg:leading-[80px] text-[30px] leading-[36px] font-semibold text-center";
    titleCname+= slim ? " max-w-[90%]" : " max-w-[800px]";

    return <>
        <div className={wrapperCname} style={nobg ? {} : {backgroundImage: `url('/comment-ca/comment-ca-marche-banner.webp')`}}>
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-primary-blue opacity-90 z-1"></div>
            <div className="flex flex-col gap-[52px] items-center justify-center w-full">
                <div className="flex flex-col gap-[27px] items-center justify-center lg:max-w-[1012px] max-w-[90vw] mx-auto relative z-2 w-full">
                    <h1 className={titleCname}>
                        {
                            data.titles.h1.map((obj: {text: string, isgrad: boolean}, index: number)=> (
                                obj.isgrad ?
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500" key={"h1-" + index}>{obj.text}</span>
                                    :
                                    <span key={"h1-" + index}>{obj.text}</span>
                            ))
                        }
                    </h1>
                    {
                        data.titles.p
                        &&
                        <p className="lg:text-[20px] text-[#f4f4f5] lg:leading-[24px] text-[16px] leading-[19.2px] font-normal font-dm-sans text-center">{data.titles.p}</p>
                    }
                </div>
                {data.extras &&
                    <Extras data={data}/>
                }
            </div>
        </div>
    </>;
};

const Extras= ({data, fat=false}: {data: any, fat?: boolean})=> {

    const [searchParams, setSearchParams]= useSearchParams();

    const domainID= (searchParams.get('id'));

    const [domainStateID, setDomainStateID]= useRecoilState<any>(global_domain_id);

    useEffect(()=>{
        // console.log(domainID);
        setDomainStateID(domainID);
    }, []);

    const history= useNavigate();
    
    const gotoInfo = () => {
        history('/externalisation-appels-assistants-virtuels');
    };

    return <div className="flex flex-col gap-[27px] items-center justify-center lg:max-w-[1080px] max-w-[90vw] mx-auto relative z-2 w-full">
        <div className={`rounded-[30px] bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 lg:px-[87px] px-[30px] lg:py-[50px] py-[40px] flex flex-col items-center gap-[30px] text-white ${fat ? 'max-w-[1080px]' : 'max-w-[669px]'}`}>
            <div className="flex flex-col gap-[20px]">
                <div className="flex flex-col gap-[14px]">
                    <h3 className="font-bold md:text-[33px] md:leading-[100%] text-[23px] leading-[27px] text-center">{data.extras.h3}</h3>
                    <h4 className="font-bold md:text-[22px] md:leading-[100%] text-[18px] leading-[100%] text-center">{data.extras.h4}</h4>
                </div>
                <p className="font-light md:text-[20px] md:leading-[100%] text-[16px] leading-[100%] text-center opacity-80">{data.extras.p}</p>
            </div>
            <BigWhiteButton text={data.extras.button} onClick={gotoInfo} cString=" !text-pink-500 w-max px-[27px] py-[12.5px] md:text-[22px] text-[19px] hover:bg-[#fff] hover:scale-105" />
        </div>
    </div>;
};

const SliderByTwo= () => {
    return <>
        <div className="w-full bg-[#f4f4f5] flex justify-center lg:py-[100px] py-[67px]">
            <TwoByTwoSlider/>
        </div>
    </>;
};

const WeirdCallToAction = () => {
    useGSAP(()=>{
        gsap.from(".sub-fade-cta-1", {
            y: 50,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".sub-fade-cta-1",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
        gsap.from(".sub-fade-cta-2", {
            y: 50,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".sub-fade-cta-2",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
    }, []);
    return<>
        <div className="flex gap-0 w-full flex lg:flex-row flex-col">
            <div className="bg-primary-blue flex lg:py-[145px] lg:px-[104px] py-[80px] px-[35px] lg:justify-end justify-center grow">
                <div className="flex flex-col gap-[30px] max-w-[545px]">
                    <div className="h-[180px] w-full rounded-[20px] overflow-hidden relative">
                        <img src="/about-images/about-03.webp" alt="Un recruteur dans un chambre vu de dos" className="w-full absolute top-[50%] left-0 transform translate-y-[-50%]"/>
                    </div>
                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 lg:text-[30px] lg:leading-[36px] text-[25px] leading-[30px] font-semibold">Vous êtes une entreprise ?</div>
                    <div className="text-white lg:text-[35px] lg:leading-[42px] text-[30px] leading-[36px] font-semibold sub-fade-cta-1">Confiez votre projet à Wall of Share !</div>
                    <p className="font-normal font-dm-sans lg:text-[20px] lg:leading-[26.04px] text-[16px] leading-[20.83px] text-[#bbbbc4] sub-fade-cta-1">Avec Wall of Share, rencontrez le talent qui correspond exavtement à votre besoin. Simplifiez votre processus de recrutement et accédez rapidement à des experts prêts à relever vos défis.</p>
                    <div className="w-full sub-fade-cta-1">
                        <RoundBluePlain text="Trouver un freelance" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px] font-semibold" isButton={false} to="/inscription-entreprises" />
                    </div>
                </div>
            </div>
            <div className="bg-[#f4f4f5] flex lg:py-[145px] lg:px-[104px] py-[80px] px-[35px] lg:justify-start justify-center grow">
                <div className="flex flex-col gap-[30px] max-w-[545px]">
                    <div className="h-[180px] w-full rounded-[20px] overflow-hidden relative">
                        <img src="/acceuil-images/action-02.webp" alt="Une freelance travaillant sur un ordinateur" className="w-full absolute top-[50%] left-0 transform translate-y-[-50%]"/>
                    </div>
                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 lg:text-[30px] lg:leading-[36px] text-[25px] leading-[30px] font-semibold">Vous êtes un freelance ?</div>
                    <div className="text-primary-blue lg:text-[35px] lg:leading-[42px] text-[30px] leading-[36px] font-semibold sub-fade-cta-2">Mettez en valeur vos compétences !</div>
                    <p className="font-normal font-dm-sans lg:text-[20px] lg:leading-[26.04px] text-[16px] leading-[20.83px] text-[#6f6f6f] sub-fade-cta-2">Rejoignez une communauté d'experts et accédez à des projets qui correspondent à vos compétences. Avec Wall of Share, valorisez votre expertise et trouvez des missions qui vous stimulent.</p>
                    <div className="w-full sub-fade-cta-2">
                        <RoundGreyPlain text="Trouver un projet" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px] font-semibold" isButton={false} to="/inscription-freelances" />
                    </div>
                </div>
            </div>
        </div>
    </>;
};


const CommentCa= () => {
    const type= "non-default";
    return (<div className={`${type === 'non-default' ? 'bg-[#F4F4F5]' : ''}  py-[140px] relative`}>
        <div className="w-full max-w-[100vw]">
            <div className='lg:w-[76%] lg:px-0 px-8 mx-auto max-w-[1152px] lg:min-w-[1000px]'>
                <CommentCaEnTete type={type} />
                <CommentCaSteps type={type} />
                <div className="w-max mx-auto mt-[50px]">
                    <RoundGreyPlain text="Lancez votre projet aujourd'hui" className="px-[40px] py-[16px]" isButton={false} to="/parcours-entreprise" />
                </div>
            </div>
        </div>
    </div>);
};

export const CommentCaEnTete= ({type}: any) => {
    return (<>
        <div className=' text-center text-primary-blue font-bold text-4xl mb-[.7em]'>
            <div>Comment ça marche ?</div>
        </div>

        <div className='text-[#6F6F6F] text-center font-medium my-[1rem] text-xl lg:w-4/5 mx-auto'>
            {
                type === 'non-default' ?
                    (
                        <>Découvrez un processus simple et rapide pour trouver les meilleurs talents et gérer vos projets en toute sérénité, de la publication de votre mission à sa réalisation.</>
                    ) :
                    (
                        <div>Suivez ces étapes simples pour maximiser vos opportunités et accéder à des missions <br /> de qualité avec Wall-of-Share.</div>
                    )
            }
        </div>
    </>
    );
};

export const CommentCaSteps= ({type}: any) => {
    useGSAP(()=>{
        gsap.from(".sub-fade-x", {
            x: 70,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".sub-fade-x",
                start: "top center",
                toggleActions: "play none play reverse"
            }
        });
    }, []);
    return (
        <>
            <div className='lg:grid grid-cols-3 space-y-8 lg:space-y-0 gap-x-6 mt-8 flex flex-col items-center'>
                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full sub-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O1</div>
                    <div className='font-bold text-primary-blue text-xl'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Créez votre compte et publiez votre mission rapidement</>
                                ) : (
                                    <>Créez votre compte et démarquez-vous avec un profil complet</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Un processus d'inscription simplifié pour vous permettre de publier votre première mission en quelques minutes seulement.</>
                                ) : (
                                    <>Un profil soigné et complet augmente vos chances d'être sélectionné pour des projets de qualité. Inscrivez-vous et attirez les entreprises qui recherchent vos compétences.</>
                                )
                        }
                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full sub-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O2</div>
                    <div className='font-bold text-primary-blue text-xl'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Accédez à des freelances qualifiés en un temps record</>
                                ) : (
                                    <>Découvrez des missions de qualité avec des entreprises sérieuses</>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Explorez une sélection de freelances triés sur le volet, correspondant parfaitement à vos besoins. Consultez les profils, évaluez les compétences et choisissez vos talents idéaux.</>
                                ) : (
                                    <>Accédez à des projets soigneusement vérifiés et proposés par des entreprises sérieuses qui valorisent votre expertise et sont prêtes à payer le juste prix pour des résultats exceptionnels.</>
                                )
                        }

                    </div>
                </div>

                <div className={`${type === 'non-default' ? 'bg-white' : 'bg-[#F4F4F5]'} px-8 py-8 rounded-3xl max-w-[350px] h-full sub-fade-x`}>
                    <div className='bg-gradient-to-r text-[80px] from-purple-500 via-red-500 to-orange-500 bg-clip-text text-transparent font-semibold w-max'>O3</div>
                    <div className='font-bold text-primary-blue text-xl'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Suivi de projet simplifié avec gestion automatisée</>
                                ) : (
                                    <>Développez votre carrière avec des opportunités exclusives </>
                                )
                        }
                    </div>
                    <div className='text-[#6F6F6F] font-medium my-5'>
                        {
                            type === 'non-default' ?
                                (
                                    <>Gestion de contrats, paiements sécurisés et suivi de mission – tout est géré sur notre plateforme pour vous garantir une expérience fluide.</>
                                ) : (
                                    <>Accédez à des projets variés et de haute qualité qui vous permettent de renforcer vos compétences et de bâtir une solide réputation.</>
                                )
                        }

                    </div>
                </div>
            </div>
        </>
    );
};

const BlueBanner= () => {
    useGSAP(()=>{
        gsap.from(".sub-fade-y", {
            y: 70,
            duration: 1,
            opacity: 0,
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".sub-fade-y",
                start: "top 80%",
                toggleActions: "play none play reverse"
            }
        });
    }, []);
    return<>
        <div className="lg:w-3/4 lg:w-5/6 w-[92%] max-w-[1144px] bg-[#1D1D39] lg:py-[76px] py-[39px] lg:px-[6rem] px-[1.8em] rounded-[30px] flex flex-col justify-center lg:items-start items-center gap-[1.5em] mx-auto relative">
            <h2 className="text-white lg:text-left text-center w-full font-semibold lg:text-[40px] lg:leading-[48px] text-[25px] leading-[30px] sub-fade-y">Talents de haute qualité, tarifs inégalés</h2>
            <p className="text-[#BBBBC4cc] font-dm-sans font-normal lg:text-[20px] lg:leading-[24px] text-[16px] leading-[19px] mb-[15px] lg:text-left text-center sub-fade-y">Profitez des meilleurs freelances, rigoureusement séléctionnés et testés, à des prix défiant toute concurence.</p>
            <div className="w-full sub-fade-y">
                <RoundBluePlain text="Découvrez nos talents d'exception" className="px-[27px] py-[13.5px] text-[18px] leading-[23.44px]" isButton={false} to={"/inscription-entreprises"} />
            </div>
            <img src="/images/flyer.png" alt="flyer" className="w-[13rem] absolute right-0 z-20 top-[50%] transform translate-y-[-50%] hidden lg:block"/>
        </div>
    </>;
};

export default SubCategory;